import React from 'react';
import { Paper, Grid, Typography, Box } from '@material-ui/core';

const StatsCard = ({ title, count, icon, color, subText, onClick }) => {
    return (
        <Paper
            className={`w-full h-full relative overflow-hidden transition-transform transform hover:scale-105 duration-300 ${onClick ? 'cursor-pointer hover:shadow-xl' : ''}`}
            elevation={3}
            style={{ borderRadius: '16px' }}
            onClick={onClick}
        >
            <div
                className="absolute top-0 left-0 w-2 h-full"
                style={{ backgroundColor: color }}
            />
            <Box className="p-6 h-full flex flex-col justify-between">
                <div className="flex justify-between items-start">
                    <div>
                        <Typography variant="subtitle1" className="text-gray-500 font-medium whitespace-nowrap">
                            {title}
                        </Typography>
                        <Typography variant="h3" className="font-bold text-gray-800 mt-2">
                            {count}
                        </Typography>
                    </div>
                    <div
                        className="p-3 rounded-xl shadow-sm"
                        style={{
                            backgroundColor: `${color}20`,
                            color: color
                        }}
                    >
                        {icon}
                    </div>
                </div>
                {subText && (
                    <Typography variant="caption" className="mt-4 text-gray-400">
                        {subText}
                    </Typography>
                )}
            </Box>
        </Paper>
    );
};

export default StatsCard;
